<template>
  <div>
    <VSection label="transactions.summary_headline">
      <VDescriptionListDivided>
        <VEntry :data="transactionDetails" field="transactionId" name="transactions.summary_transaction_id_label" />
        <VEntryDate date :data="transactionDetails" field="start" name="transactions.summary_transaction_start_label" />
        <VEntry :data="transactionDetails" field="stateDescription" name="transactions.summary_transaction_status_label" />
        <VEntry :data="transactionDetails" field="vasCode" name="transactions.summary_vas_code_label" />
        <VEntry :data="transactionDetails" field="vasCodeDescription" name="transactions.summary_service_name_label" />
        <VEntryNumber
          currency-field="retailChargeBooked.currency"
          :data="transactionDetails"
          field="retailChargeBooked.gross"
          name="transactions.summary_retail_price_booked_label"
        />
        <VEntry v-slot="{ data }" :data="transactionDetails" field name="transactions.summary_charging_mode_label">
          <template v-if="data.subscriptionChargeTypeId">
            {{ $tf(`transactions.chargeTypeSubscription${getSubscriptionChargeTypeMapping(data.subscriptionChargeTypeId)}`) }}
          </template>
          <template v-else-if="data.confirmationId">
            {{ $t('transactions.chargeTypePPERecurring') }}
          </template>
          <template v-else>
            {{ $t('transactions.chargeTypePPEOneOff') }}
          </template>
        </VEntry>
        <VEntry :data="transactionDetails" field="flagBundlePurchase" boolean name="transactions.summary_content_bundles_purchased_label" />
        <VEntry :data="transactionDetails" field="flagBundleUsage" boolean name="transactions.summary_content_bundles_used_label" />
        <VEntry :data="transactionDetails" field="subscriptionDataTemplateId" name="transactions.summary_content_subscription_template_id_label" />
        <VEntryDate date :data="transactionDetails" field="subscriptionDataBeginOfChargingPeriod" name="transactions.summary_charging_interval_start_label" />
        <VEntryDate date :data="transactionDetails" field="subscriptionDataEndOfChargingPeriod" name="transactions.summary_charging_interval_stop_label" />
      </VDescriptionListDivided>
    </VSection>
    <VSection v-if="hasDetailsErrorSection" label="transactions.error_information_headline">
      <VDescriptionListDivided>
        <VEntry :data="transactionDetails" field="errorInfo.responsible" name="transactions.error_information_responsible_label" />
        <VEntry :data="transactionDetails" field="errorInfo.retry" name="transactions.error_information_repeatable_label" />
        <VEntry :data="transactionDetails" field="errorInfo.calculatedReasonDescription" name="transactions.error_information_reason_label" />
        <VEntry :data="transactionDetails" field="errorInfo.calculatedReasonInfoDescription" name="transactions.error_information_detail_label" />
        <VEntry :data="transactionDetails" field="errorInfo.codeErrorDetailDescription" name="transactions.error_information_internal_label" />
        <VEntry :data="transactionDetails" field="errorInfo.backendErrorIps" name="transactions.error_information_causing_backend_label" />
        <VEntry :data="transactionDetails" field="errorInfo.backendError" name="transactions.error_information_backend_error_label" />
      </VDescriptionListDivided>
    </VSection>
  </div>
</template>

<script>
import VSection from '@/components/Section';
import VDescriptionListDivided from '@/components/DescriptionList/Divided';
import VEntry from '@/components/DescriptionList/Entry';
import VEntryDate from '@/components/DescriptionList/EntryDate';
import VEntryNumber from '@/components/DescriptionList/EntryNumber';

export default {
  name: 'PaymentTransactionsDetailsIntro',

  components: {
    VSection,
    VDescriptionListDivided,
    VEntry,
    VEntryDate,
    VEntryNumber,
  },

  props: {
    transactionDetails: {
      type: Object,
      required: false,
      default: null,
    },
  },

  computed: {
    hasDetailsErrorSection() {
      if (!this.transactionDetails) {
        return false;
      }
      return (
        (!!this.transactionDetails.errorInfo.calculatedReasonDescription && this.transactionDetails.errorInfo.calculatedReasonDescription !== '') ||
        !!this.transactionDetails.errorInfo.calculatedReasonInfoDescription
      );
    },
  },

  methods: {
    getSubscriptionChargeTypeMapping(id) {
      switch (id) {
        case 1:
          return '1Initial';
        case 2:
          return '2Subsequent';
        case 3:
          return '3OneTime';
        case 4:
          return '4RecurringChargeRefund';
        case 5:
          return '5RecurringChargeLoss';
        case 6:
          return '6SetupCharge';
      }
    },
  },
};
</script>
